module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/favicon-16x16-a1972a085c47dccc7cf7a650080b0ff1.png";